import { Component } from "@angular/core";

@Component({
  selector: "app-ticket-follow-on-dialog",
  templateUrl: "./ticket-follow-on-dialog.component.html",
  styleUrls: ["./ticket-follow-on-dialog.component.css"]
})
export class TicketFollowOnDialogComponent {
  constructor() {}
}
